
(ns app.strive-forms.question-fields.number-input-field
  (:require [app.strive-forms.component-multi-methods :refer [calc-error-message
                                                              show-action-btn? update-question-input-data update-question-input-local]]
            [app.strive-forms.defaults :refer [default-values]]
            [app.strive-forms.events :as sfevents]
            [app.strive-forms.helper-functions :refer [check-button-status
                                                       color-condition
                                                       component-alignment get-default-text-val get-error-message-color get-required-message
                                                       on-focus-toggle required-and-empty? save-value-on-last-page set-values-for-button!
                                                       update-preview-panel!]]
            [app.strive-forms.styles :refer [num-input-style
                                             responsive-input-field-border-class
                                             responsive-input-field-style warning-notification]]
            [cljs.tools.reader :refer [read-string]]
            [clojure.string :as s]
            [goog.string :as gstring]
            [goog.string.format]
            [re-com.core :as re-com :refer [h-box v-box]]
            [re-frame.core :as re-frame]
            [reagent-mui.material.box :refer [box]]
            [reagent-mui.material.text-field :refer [text-field]]
            [reagent.core :as r]))



(defn validate-number [num min-number max-number is-min-exist? is-max-exist?]
  (cond (and is-min-exist? is-max-exist?) (<= min-number (read-string num) max-number)
        (and is-min-exist? (not is-max-exist?)) (>= (read-string num) (int min-number))
        (and is-max-exist? (not is-min-exist?)) (<= (read-string num) max-number)
        (and (not is-max-exist?) (not is-min-exist?)) (number? (read-string num))))


(defmethod update-question-input-local "number" [{:keys [input-data field-id input-value]}]
  (re-frame/dispatch [::sfevents/update-input-local
                      {:input-data input-data :key (keyword field-id) :value input-value}]))

(defmethod update-question-input-data "number" [{:keys [input-data field-id input-value]}]
  (update input-data (keyword field-id) (fn [value]
                                          (assoc value :value input-value))))

(defn- get-num-ivalid-error-message [{:keys [form-messages]}]
  (:number_invalid form-messages (:invalid (:number (:errors default-values)))))

(defn- get-num-limits-error-msg [{:keys [form-messages min-number max-number]}]
  (gstring/format (:min_max_limit form-messages (:min-max-limit (:number (:errors default-values)))) min-number max-number))

(defn- get-num-max-limit-error-msg [{:keys [form-messages max-number]}]
  (gstring/format (:number_max_limit form-messages (:max-limit (:number (:errors default-values)))) max-number))

(defn- get-num-min-limit-error-msg [{:keys [form-messages min-number]}]
  (gstring/format (:number_min_limit form-messages (:min-limit (:number (:errors default-values)))) min-number))

(defmethod calc-error-message "number" [{:keys [min-number max-number is-min-exist? is-max-exist? input-value field form-messages valid? new-session]}]
  (let [text-val (:input-value (first @input-value))
        required-message (get-required-message {:form-messages form-messages})
        min-limit-error-message (get-num-min-limit-error-msg {:form-messages form-messages :min-number min-number})
        max-limit-error-message (get-num-max-limit-error-msg {:form-messages form-messages :max-number max-number})
        min-max-limit-error-message (get-num-limits-error-msg {:form-messages form-messages :min-number min-number
                                                               :max-number max-number})
        invalid-error-message (get-num-ivalid-error-message {:form-messages form-messages})]
    (cond
      @valid? ""
      (and (not (:is_required field)) (s/blank? text-val)) ""
      (and (not @valid?) (:is_required field) (s/blank? text-val)) required-message
      (and (not @valid?) is-min-exist? is-max-exist?) min-max-limit-error-message
      (and (not @valid?) is-min-exist? (not is-max-exist?)) min-limit-error-message
      (and (not @valid?) is-max-exist? (not is-min-exist?)) max-limit-error-message
      (and (not @valid?) (not is-max-exist?) (not is-min-exist?)) invalid-error-message
      :else "")))

(defmethod show-action-btn? "number" [_]
  true)



(defn on-change-action [{:keys [text-val value number-valid? number-button-disabled? new-session
                                min-number max-number is-min-exist? is-max-exist? final-page? input-data field-id
                                regenerate-display-fields]}]
  (reset! text-val value)
  (when @new-session (swap! new-session not))
  (if (validate-number @text-val min-number max-number is-min-exist? is-max-exist?)
    (when-not (s/blank? @text-val) (reset! number-valid? true)
              (reset! number-button-disabled? false) ;TODO: cleaner code, process-response make 1 general, for all fields
              (save-value-on-last-page {:final-page? final-page? :input-data input-data :field-id field-id
                                        :regenerate-display-fields regenerate-display-fields :text-val text-val}))
    (do (reset! number-valid? false)
        (reset! number-button-disabled? true))))

(defn number-input-label [{:keys [text-val theme-data min-number max-number is-min-exist? is-max-exist?
                                  number-button-disabled? form-messages on-focus number-valid? new-session
                                  final-page? input-data field-id regenerate-display-fields]}]
  [h-box
   :class (responsive-input-field-border-class {:border-color (color-condition {:valid? @number-valid?
                                                                                :on-focus @on-focus
                                                                                :theme-data theme-data
                                                                                :default-color (:dark-gray (:themes default-values))})
                                                :border-size (str (if @on-focus "2px" "1px") " solid")
                                                :margin (when @on-focus "-1px")
                                                :width "95%"})
   :children [[box {:sx {:display "flex" :alignItems "flex-end"}}
               [text-field {:variant "filled"
                            :class (num-input-style)
                            :style {:background "transparent"}
                            :max-rows 1
                            :type :number
                            :defaultValue @text-val
                            :model          @text-val
                            :InputProps  {:disableUnderline true}
                            :InputLabelProps {:shrink (if (s/blank? @text-val) nil "true")}
                            :label  (:number_input_label form-messages (:number_input_label default-values))
                            :on-focus (on-focus-toggle on-focus)
                            :on-change (fn [x]
                                         (on-change-action {:text-val text-val :value (-> x .-target .-value)
                                                            :number-valid? number-valid? :number-button-disabled? number-button-disabled?
                                                            :min-number min-number :max-number max-number
                                                            :is-min-exist? is-min-exist? :is-max-exist? is-max-exist?
                                                            :new-session new-session :final-page? final-page? :input-data input-data
                                                            :field-id field-id :regenerate-display-fields regenerate-display-fields}))
                            :on-blur (on-focus-toggle on-focus)}]]]])

(defn number-input-field [{:keys [field field-id input-data default-value current-page index]}]
  (let [text-val (r/atom (get-default-text-val {:input-data input-data :field-id field-id :default-value default-value
                                                :current-page @current-page :index index}))
        number-button-disabled? (r/atom true)
        new-session (r/atom true)
        min-number (read-string (:minimum_number (:additional_settings field)))
        max-number (read-string (:maximum_number (:additional_settings field)))
        is-min-exist? (some? min-number)
        is-max-exist? (some? max-number)
        on-focus (r/atom false)
        number-valid? (r/atom true)]
    (when (and @number-valid? (not (s/blank? @text-val))) (reset! number-button-disabled? false))
    (fn [{:keys [field theme-data form-messages input-value  button-ids-for-button is-multi-question? input-data]}]
        (update-preview-panel! {:input-data input-data :field-id field-id
                                :value-to-update @text-val
                                :condition (not (s/blank? @text-val))})
        (add-watch text-val :watcher
                   (fn []
                     (set-values-for-button! {:input-value input-value :component-input-value text-val
                                              :field-id field-id :type (:type field)})))
        (check-button-status {:component-button-disabled? number-button-disabled?
                              :button-ids-for-button button-ids-for-button
                              :field-id field-id})
        (required-and-empty? {:text-val text-val :field field :valid? number-valid?})
        [v-box
         :width "100%"
         :align (component-alignment is-multi-question?)
         :justify :center
         :children [[:div
                     {:class
                      (responsive-input-field-style {:input-font-color (color-condition {:valid? @number-valid?
                                                                                         :on-focus false
                                                                                         :theme-data nil
                                                                                         :default-color (:light-gray (:themes default-values))})
                                                     :title-field-color (color-condition {:valid? (not @number-button-disabled?)
                                                                                          :on-focus @on-focus
                                                                                          :theme-data theme-data
                                                                                          :default-color (:dark-gray (:themes default-values))
                                                                                          :is-label? true})
                                                     :border-color (color-condition {:valid? @number-valid?
                                                                                     :on-focus @on-focus
                                                                                     :theme-data theme-data
                                                                                     :default-color (:dark-gray (:themes default-values))})})}
                     [number-input-label {:text-val text-val :theme-data theme-data :min-number min-number
                                          :max-number max-number :is-min-exist? is-min-exist?
                                          :on-focus on-focus :form-messages form-messages
                                          :number-button-disabled? number-button-disabled? :new-session new-session
                                          :is-max-exist? is-max-exist? :number-valid? number-valid?}]
                     [:div {:class (warning-notification {:width "350px"
                                                          :color (get-error-message-color new-session)})}
                      (calc-error-message {:input-value input-value :valid? number-valid? :type "number"
                                           :field field :form-messages form-messages
                                           :new-session new-session
                                           :min-number min-number :max-number max-number
                                           :is-min-exist? is-min-exist? :is-max-exist? is-max-exist?})]]]])))
